import Login from 'apa/containers/Login'
import Signup from 'apa/containers/Signup'
import ForgotPassword from 'apa/containers/ForgotPassword'
import {RouteConfig as CustomersConfig} from 'customers/RouteConfig'
import {RouteConfig as ItemsConfig} from 'items/RouteConfig'
import {RouteConfig as CatalogConfig} from 'catalog/RouteConfig'
import {RouteConfig as InvoicesConfig} from 'invoices/RouteConfig'
import {RouteConfig as ManualsConfig} from 'manuals/RouteConfig'
import {RouteConfig as TemplateConfig} from 'template/RouteConfig'
import {RouteConfig as O365Config} from 'o365/RouteConfig'
import {RouteConfig as TrainingConfig} from 'training/RouteConfig'
import Welcome from 'apa/containers/Welcome';
import Training from 'apa/containers/Training';
import Test from 'apa/containers/Test';
import Evaluation from 'apa/containers/Evaluation';
import TrainingOverview from 'apa/containers/TrainingOverview';

export const RouteConfig = [
  {
    path: '/',
    component: Login,
    public: true
  },
  {
    path: '/login',
    component: Login,
    public: true
  },
  {
    path: '/signup',
    component: Signup,
    public: true
  },
  {
    path: '/forgotpassword',
    component: ForgotPassword,
    public: true
  },
  {
    path: '/training/welcome',
    component: Welcome,
    public: false
  },
  {
    path: '/training/do',
    component: Training,
    public: false
  },
  {
    path: '/training/test',
    component: Test,
    public: false
  },
  {
    path: '/training/status',
    component: Evaluation,
    public: false
  },
  {
    path: '/training/overview/:uuid',
    component: TrainingOverview,
    public: true
  },
  ...CustomersConfig,
  ...ItemsConfig,
  ...CatalogConfig,
  ...InvoicesConfig,
  ...ManualsConfig,
  ...TemplateConfig,
  ...O365Config,
  ...TrainingConfig
]
